"use strict";export const generateRandomHex=()=>{const e="0123456789abcdef";let t="";for(let n=0;n<10;n++){const o=Math.floor(Math.random()*e.length);t+=e[o]}return t};
